export default __webpack_public_path__ + "static/media/gasTankBlue.4a357f8f.jpg";